
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Typography, Box, TextField } from '@mui/material';
import { ModalClose } from '../assets/icons';
import Grid from '@mui/material/Grid2';


interface AddCardDetailsProps {
  open: boolean;
  onClose: () => void;
  title: string;
  content: string;
  onConfirm: () => void;
}

const AddCardDetails: React.FC<AddCardDetailsProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} className='card-details-modal' sx={{ '& .MuiDialog-paper': { width: '661px', maxWidth: '661PX', borderRadius: '24px', border: '1px solid #E8E8EA' } }}>
      <DialogTitle sx={{ m: 0, }} p={{ xs: "16px !important", sm: "32px" }}>
        <Typography color='#333333' fontSize={{ xs: "22px", sm: "28px" }} fontWeight='500' >Add Card details</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={() => ({
            position: 'absolute',
            right: { xs: "17px" },
            top: { xs: "15px" },

          })}
        >
          <ModalClose></ModalClose>
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ borderTop: 'none', borderBottom: 'none', p: { xs: "0 16px 16px", sm: "0 32px 32px" } }}>
        <Box mb='24px'>
          <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Name on Card</Typography>
          <TextField
            variant="outlined"
            placeholder='Enter your full name'
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: '8px',
                borderColor: '#C7C7C7',
              },

              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: '#333333',
                border: '1px solid'
              },

              "& .MuiOutlinedInput-input": {
                padding: '14px 16px',
              },
              "&.MuiInputBase-input::placeholder": {
                color: '#333333',
                fontSize: '16px',
                opacity: '0.8'
              },

            }}
            fullWidth
          />
        </Box>
        <Box mb='24px'>
          <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Card Number</Typography>
          <TextField
            variant="outlined"
            placeholder='9871 0357 7551 9862'
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: '8px',
                borderColor: '#C7C7C7',
              },

              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: '#333333',
                border: '1px solid'
              },

              "& .MuiOutlinedInput-input": {
                padding: '14px 16px',
              },
              "&.MuiInputBase-input::placeholder": {
                color: '#333333',
                fontSize: '16px',
                opacity: '0.8'
              },
            }}
            fullWidth
          />
        </Box>
        <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>Valid through</Typography>
            <TextField
              variant="outlined"
              placeholder='08/28'
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: '8px',
                  borderColor: '#C7C7C7',
                },

                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: '#333333',
                  border: '1px solid'
                },

                "& .MuiOutlinedInput-input": {
                  padding: '14px 16px',
                },
                "&.MuiInputBase-input::placeholder": {
                  color: '#333333',
                  fontSize: '16px',
                  opacity: '0.8'
                },
              }}
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' sx={{ opacity: '0.6' }}>CVV</Typography>
            <TextField
              variant="outlined"
              placeholder='***'
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: '8px',
                  borderColor: '#C7C7C7',
                },

                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: '#333333',
                  border: '1px solid'
                },

                "& .MuiOutlinedInput-input": {
                  padding: '14px 16px',
                },
                "&.MuiInputBase-input::placeholder": {
                  color: '#333333',
                  fontSize: '16px',
                  opacity: '0.8'
                },
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ mb: { xs: "16px", sm: "32px" }, mr: { xs: "11px", sm: "32px" } }}>
        <Button onClick={onClose} color="primary" sx={{
          border: '1px solid #E8EAF0', px: '22px', color: '#2B2B30 !important', textTransform: 'capitalize', borderRadius: '8px', mr: '16px', '&:hover': {
            border: '1px solid #E8EAF0 !important',
            boxShadow: 'unset !important'
          },
        }}>
          Cancel
        </Button>
        <Button onClick={onConfirm} sx={{
          textTransform: 'capitalize', bgcolor: '#614EFA', color: '#FFFFFF !important', px: '24px', height: '40px', borderRadius: '8px', '&:hover': {
            border: 'none !important'
          },
        }}>Add Card</Button>
      </DialogActions>
    </Dialog>
  );
};
export default AddCardDetails;
